import { getListingPosition } from './getListingPosition'
import { Listing } from '../../../reducers/types/reducerTypes'
import { ListingPositionEnum } from '../types'

import type { Dayjs } from 'dayjs'

const filterListings = (
  listings: Listing[],
  now: Dayjs,
  scheduleStart: Dayjs,
  scheduleEnd: Dayjs
) => {
  const filteredListings: Array<{
    listing: Listing
    position: ListingPositionEnum
  }> = []

  listings.forEach((listing) => {
    const listPosition = getListingPosition(
      listing,
      now,
      scheduleStart,
      scheduleEnd
    )
    if (
      listPosition !== ListingPositionEnum.notInSchedule &&
      listPosition !== ListingPositionEnum.startsAfterScheduleEnd &&
      listPosition !== ListingPositionEnum.startsBeforeScheduleStartAndEnded
    ) {
      filteredListings.push({ listing, position: listPosition })
    }
  })

  return filteredListings
}

export { filterListings }
